export default function WhenDelegationFails() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда делегирование не работает
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Иногда проблема не в сотруднике, а в самой системе делегирования
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {[
            { title: 'Сотрудник не обладает компетенциями', desc: 'Делегирование задачи сотруднику, у которого нет необходимых знаний и навыков — это не делегирование, а перекладывание. Сначала — обучение, потом — задача.' },
            { title: 'Задача поставлена неясно', desc: 'Если сотрудник не понимает, что именно нужно сделать и какой результат ожидается, он не сможет выполнить задачу независимо от своей компетенции.' },
            { title: 'Руководитель не передал полномочия', desc: 'Сотруднику поручили задачу, но не дали права принимать решения. Каждое действие требует согласования — delegation превращается в бюрократию.' },
            { title: 'Нет ресурсов', desc: 'Сотрудник получил задачу, но не получил доступ к информации, бюджету, времени или помощи коллег, необходимых для её выполнения.' },
            { title: 'Сроки нереалистичны', desc: 'Задачу поставили с заведомо невыполнимым сроком. Сотрудник либо сдаст некачественный результат, либо сорвёт срок.' },
            { title: 'Требования постоянно меняются', desc: 'Руководитель добавляет новые условия и меняет критерии по ходу выполнения. Сотрудник не может планировать работу.' },
            { title: 'Отсутствует обратная связь', desc: 'Сотрудник сдал результат, но не получил обратную связь. Он не знает, хорошо ли выполнена задача и что можно улучшить в следующий раз.' },
            { title: 'Сотрудник не принимает ответственность', desc: 'Формально задача передана, но сотрудник продолжает ждать указаний и не воспринимает задачу как свою зону ответственности.' },
          ].map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-sm md:text-base text-teal-800 leading-relaxed font-semibold">
            Если делегирование систематически не работает, важно разобраться в причинах. Часто проблема не в конкретном сотруднике, а в том, как в компании устроена постановка задач, контроль и обратная связь.
          </p>
        </div>
      </div>
    </section>
  );
}